import React from "react";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


function HeaderComponent() {


    
      return (
        <header>
          <Container fluid>
            <Row>
              <Col>
                <h1>Служба механика</h1>
                <h6>Журнал ремонтов, учет неисправностей, заявки</h6>
              </Col>
              
              <Col>

              </Col>
              
              <Col>
                <p id='nameCompany'>АО "КП-Габбро", Карьер Новый Поселок</p>
              </Col>
              </Row>
            

          </Container>

          



        </header>
      )
  
    
    


};
export default HeaderComponent;
